import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { device } from '../../../utils/styled-component-mixins';
import { useEventWebinarContext } from './EventWebinarContext';

const EventDescription = ({ className }) => {
  const { eventDescription } = useEventWebinarContext();
  const [description, setDescription] = useState('');

  // Fixes SSR error.
  useEffect(() => {
    setDescription(eventDescription);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className={className} dangerouslySetInnerHTML={{ __html: description }} />;
};

const StyledEventDescription = styled(EventDescription)`
  margin-block: 4rem 8rem;

  @media ${device.deviceOnly} {
    margin-bottom: 4rem;
  }
`;

export default StyledEventDescription;
